package dev.lingvo.site.components.studio.preview

import dev.lingvo.shared.screenshots.ScreenshotLooks
import dev.lingvo.shared.screenshots.templates.SampleApp
import dev.lingvo.shared.screenshots.templates.SampleScreen
import dev.lingvo.site.components.studio.canvas.CanvasSurface
import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLCanvasElement
import org.w3c.files.Blob
import kotlin.coroutines.resume

/** Samples are generated only for labelled template previews, never for the customer's canvas. */
internal fun productionDesignLooks(): DesignLooksPort = EngineDesignLooks(
    ScreenshotLooks, ScreenshotLooks.palettes, ScreenshotLooks.iconPalettes, ::sampleScreenBlob,
)

private suspend fun sampleScreenBlob(): Blob? {
    val canvas = document.createElement("canvas") as HTMLCanvasElement
    canvas.width = 240
    canvas.height = 520
    return try {
        val layout = ScreenshotLooks.launchLayouts.first()
        val palette = ScreenshotLooks.palettes.derive(layout, SampleApp.brand)
        SampleScreen.paint(CanvasSurface(canvas.getContext("2d")), canvas.width, canvas.height, palette, "home")
        suspendCancellableCoroutine { continuation ->
            canvas.toBlob({ blob -> if (continuation.isActive) continuation.resume(blob) }, "image/png")
        }
    } finally { canvas.width = 0; canvas.height = 0 }
}
